import { useEffect, useState } from "react";
import { IntegracionService } from "../../../../../../services/auxiliar/IntegracionService";
import { IPanelUbicacionSync } from "./PanelUbicacionSync";
import { IUbicacionPost, IUbicacionSync } from "../../../../../../Interfaces/estadoEquipos/IEstadoEquipo";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../../Interfaces/base/IResponse";

export const UsePanelUbicacionSync=(props:IPanelUbicacionSync)=>{
 const [loadingSync,setLoadingSync]=useState<boolean>(false)
 const [ubicacioneSync,setUbicacionesSync]=useState<IUbicacionSync[]>([])
 const [status, setStatus] = useState<codigosRespuesta>(0);
 const [mensaje, setMensaje] = useState<string>("");
 const [loading,setLoading]=useState<boolean>(false)
 const getUbiSync=()=>{
    setLoadingSync(true)
    IntegracionService.GetUbicaciones(props.nivel).then((res)=>{
        if(res.status==200){
           setUbicacionesSync(res.data)
        }
        setLoadingSync(false)
    }).catch((e)=>{
        setLoadingSync(false)
    })
 }
 const SyncronizarUbicaciones=()=>{
    setLoading(true)
    const request:IUbicacionPost={
        nivel: props.nivel,
        ubicacionesIntegrar: ubicacioneSync
    }
    IntegracionService.PostUbicacion(request).then((res)=>{
        if(res.status==200){
            setStatus(200)
            setMensaje(res.data.mensaje);
            setTimeout(() => {
                props.reload?.();
                reset()
            }, 3000)
        }else{
            setStatus(500)
        }
        setLoading(false)
    }).catch((e)=>{
        if (
            e.response?.data &&
            'type' in e.response.data &&
            'title' in e.response.data &&
            'status' in e.response.data &&
            'instance' in e.response.data &&
            'errors' in e.response.data
          ) {
            const errorResponse = e.response.data as IResponseApiFluent;
            const mensajeError = errorResponse.errors.join('\n');
            setMensaje(mensajeError);
          } else {
            console.log('Error detallado:', e);
            setMensaje("Error Inesperado");
          }
          setStatus(500);
          setLoading(false);
    })
 }
 const reset=()=>{
    setMensaje("")
        setStatus(0)
        props.onDismiss()
 }
 useEffect(()=>{
    if(props.isOpen){
        getUbiSync()
    }
 },[props.isOpen])
 return {ubicacioneSync,loadingSync,SyncronizarUbicaciones,reset,status,loading,mensaje}
}